/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlSortCriteria {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlSortCriteria>): ComplianceAssessmentControlSortCriteria {
        let obj = Object.assign(new ComplianceAssessmentControlSortCriteria(), model);
        ComplianceAssessmentControlSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlSortCriteria>): ComplianceAssessmentControlSortCriteria {
        if (!model) return null;
        return ComplianceAssessmentControlSortCriteria.newInstance(<ComplianceAssessmentControlSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlSortCriteria) {
        if (!obj) return;

        models.ComplianceAssessmentControlSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlSortCriteria): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ComplianceAssessmentControlSortColumn;

    ascending: boolean;

}
